import React, { Component } from 'react';

import ListaDeConcedentes from './ListaDeConcedentes';
import { Endereco } from './Endereco';
import { RepresentanteLegalPJ } from './RepresentanteLegalPJ';
import api from '@api';
import navigate from '@/utils/navigate';

export default class CadastrarCampoDeEstagio extends Component {
	constructor() {
		super();

		this.state = {
			listaDeConcedentes: [],

			dados: {
				nome: '',
				telefone: '',
				endereco: {
					cep: '',
					logradouro: '',
					bairro: '',
					cidade: '',
					uf: '',
				},
			},

			representanteLegalAtivo: false,
		};

		this.carregaListaDeConcedentes = this.carregaListaDeConcedentes.bind(this);
		this.replicarDadosDoConcedente = this.replicarDadosDoConcedente.bind(this);

		this.ativaRepresentanteLegal = this.ativaRepresentanteLegal.bind(this);
		this.desativaRepresentanteLegal = this.desativaRepresentanteLegal.bind(this);

		this.email = React.createRef();

		this.onChange = this.onChange.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
	}

	componentDidMount() {
		this.carregaListaDeConcedentes();
	}

	carregaListaDeConcedentes() {
		api.concedentes.ListaConcedentes()
			.then((listaDeConcedentes) => {
				this.setState({ listaDeConcedentes });
			});
	}

	criarCampoDeEstagio(dados) {
		api.camposDeEstagio.Novo(dados)
			.then(() => {
				navigate('/');
			})
			.catch((erro) => {
				console.log(erro);
			});
	}

	replicarDadosDoConcedente() {
		const { dados } = this.state;
		const { concedente } = dados;

		const { nome, telefone, email, endereco } = concedente;

		const novosDados = {
			nome, telefone, email, endereco,
		};

		this.setState(prevState => (
			{
				...prevState,
				dados: {
					...prevState.dados,
					...novosDados,
				},
				replica_concedente: false,
			}
		));
	}

	ativaRepresentanteLegal(e) {
		e.preventDefault();

		this.setState(prevState => {
			const dados = {
				...prevState.dados,
				representante_legal: {
					nome: '',
					cargo: '',
				},
			};

			return ({
				dados,
				representanteLegalAtivo: true,
			});
		});
	}

	desativaRepresentanteLegal(e) {
		e.preventDefault();

		this.setState(prevState => {
			const { representante_legal, ...dados } = prevState.dados;
			return ({
				dados,
				representanteLegalAtivo: false,
			});
		});
	}

	onSubmit(e) {
		e.preventDefault();

		const { dados } = this.state;
		this.criarCampoDeEstagio(dados);
	}

	onChange(e) {
		const { name, value } = e.target;

		this.setState(prevState => ({
			dados: {
				...prevState.dados,
				[name]: value,
			},
		}));
	}

	render() {
		const { dados, listaDeConcedentes, replica_concedente, representanteLegalAtivo } = this.state;

		if (dados.concedente === undefined) {
			return (
				<ListaDeConcedentes
					listaDeConcedentes={listaDeConcedentes}
					onSelect={(concedente) => this.setState(prevState => ({ dados: { ...prevState.dados, concedente } }))}
				/>
			);
		}

		const { nome, telefone, email, endereco, representante_legal } = dados;

		if (replica_concedente) this.replicarDadosDoConcedente();

		return (
			<form className="container pb-3" onSubmit={this.onSubmit}>
				<h5 className="my-1 text-dark">Dados cadastrais do Campo de Estágio</h5>

				{replica_concedente === undefined && (
					<div className='d-flex'>
						<button className='btn btn-sm btn-primary mb-3' onClick={() => this.setState({ replica_concedente: true })}>Importar dados do concedente</button>
					</div>
				)}

				<div className="row mb-3">
					<div className="mb-2 col-12">
						<label className="form-label" htmlFor="nome">Nome</label>
						<input className="form-control" id="nome" name="nome" type="text" value={nome} onChange={this.onChange} required minLength="2" maxLength="80" pattern={'^.{2,80}$'} />
					</div>

					<div className="mb-2 col-lg-5 col-md-5 col-sm-12 col-12">
						<label className="form-label" htmlFor="telefone">Telefone</label>
						<label className="badge badge-pill badge-info">somente números</label>
						<input className="form-control" id="telefone" name="telefone" type="text" value={telefone} onChange={this.onChange} required placeholder="somente números" minLength="8" maxLength="11" pattern="^[0-9]{8,11}$" />
					</div>

					<div className="mb-2 col-lg-7 col-md-7 col-sm-12 col-12">
						<label className="form-label" htmlFor="email">Email</label>
						<input className="form-control" id="email" name="email" type="email" defaultValue={email !== undefined ? email : ''} ref={this.email} onChange={this.onChange} minLength="6" maxLength="70" />
					</div>
				</div>

				<Endereco onChange={this.onChange} value={endereco} />

				<div className="d-flex justify-content-center mb-3">
					<button className="btn btn-sm btn-outline-primary"
						onClick={representanteLegalAtivo ? this.desativaRepresentanteLegal : this.ativaRepresentanteLegal}
					>
						{
							representanteLegalAtivo
								? 'Utilizar o mesmo Representante Legal do Concedente'
								: 'Informar Representante Legal diferente do Concedente'
						}
					</button>
				</div>

				{
					representante_legal !== undefined
						? <RepresentanteLegalPJ onChange={this.onChange} value={representante_legal} />
						: null
				}

				<div className="d-flex w-100">
					<span className="flex-grow-1"></span>
					<input className="ms-auto btn btn-success" type="submit" value="Cadastrar" />
				</div>
			</form>
		);
	}
}
